const ShoppingCart = require('od-modules/cart/cart');
const fareRulesEmpty = () => ShoppingCart.take.fareRules((item) => item.committable).length === 0;
const hideByFareRules = () => Odigeo.AB.isFareRulesProductHiding && !fareRulesEmpty();

const defaultTemplate = 'default';

const rules = [
    {
        template: 'payWithGuarantee',
        validator(model) {
            return model.isPayWithGuaranteeEnabled() && !hideByFareRules();
        },
        hideTotalPrice: true,
        continueTracking: 'continueWithInsurance',
    },
    {
        template: defaultTemplate,
        continueTracking: 'continue',
    },
];

module.exports = {
    rules,
    defaultTemplate,
    onContinueTrigger: 'price-breakdown-payments:onContinueButtonClicked',
    onContinueButtonMouseOver: 'price-breakdown-payments:trackContinueButtonMouseover',
    onContinueWithPayWithGuarantee(_, productId, onSuccessCallback, onFailCallback) {
        Odigeo.trigger('payment-button:onContinueWithProductAttached', {
            productId,
            widgetSelector: (asyncWidgets) => asyncWidgets.getAncillariesModule(),
            onSuccessCallback,
            onFailCallback,
        });
    },
    isAnyInsurancesInCartOrInSession(model) {
        return model.isAnyProductIncompatibleWithCancellationInSession();
    },
    ab: {
        payWithGuarantee: {
            isReorderABEnabled: () => false,
        },
        voucherCanx: {
            isEnabled: (abs) => abs['c4arAsAVoucherDesktop'],
        },
    },
    tracking: {
        labelForRejectedButton: 'none',
    },
};
